import { MutableRefObject, useCallback, useEffect, useState } from 'react'

export const useComponentSize = <T extends HTMLElement | null>(componentRef: MutableRefObject<T>) => {
  const [width, setWidth] = useState<number | undefined>()
  const [height, setHeight] = useState<number | undefined>()
  
  const handleResize = useCallback(() => {
    setWidth(componentRef.current?.offsetWidth)
    setHeight(componentRef.current?.offsetHeight)
  }, [componentRef.current])

  useEffect(() => {
    handleResize();
  }, [])

  useEffect(() => {
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [componentRef.current, handleResize])

  return { width, height }
}
